import React, { Component } from 'react';
import { GetProdutosDetails } from '../../../../services';
import swal from 'sweetalert';
import Moment from 'moment';
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import axios from 'axios';

import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableCaption,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CButton,
  CSpinner,
  CFormInput
} from '@coreui/react';

import CIcon from '@coreui/icons-react';
import {
  cilPencil, cilTrash,
} from '@coreui/icons';

export default class List extends Component {

  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    state: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      getList: [],
      filteredList: [],
      isLoaded: false,
      mensagem:'',
      filters: {
        nome: "",
        codigo: "",
        descricao: "",
        ean: "",
      },
    };
  }

  async componentDidMount() {
    this.ListProdutos();
  }

  async ListProdutos() {
    this.setState({ isLoaded: true });
    let list = await GetProdutosDetails.ProdutosList();
    console.log('list: ', list)
    if (list) {
      this.setState({ 
        getList: list.data,
        filteredList: list.data 
      });
    }
    this.setState({ isLoaded: false });
  }

  formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const formattedDate = date.toLocaleDateString('pt-BR'); // Formato de data DD/MM/YYYY
    
    return formattedDate;
  };

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [name]: value
      }
    }), this.applyFilters);
  }

  CallCarga = async event => {
    event.preventDefault(); 
    swal({
      title: "Deseja Fazer a carga completa dos Produtos? Isto pode levar alguns minutos...",         
      icon: "info",
      buttons: true,
      dangerMode: false,
     })
      .then(async (success) => {
          if (success) { 
              this.setState({ isLoaded: true,mensagem: ' - Carga Iniciada....' })   
              const res = await axios.get('https://integradorbaoba.masterdaweb.net/api/nf_entrada/CargaProduto', {
               });
              //return res.data
              console.log(res.data)
              this.setState({ isLoaded: false,mensagem: res.data.message})
              await this.ListProdutos();
          }
      });
  } 

  applyFilters = () => {
    const { filters, getList } = this.state;
    const filteredList = getList.filter(item => {
      const nome = typeof item.filiai.nome === 'string' ? item.filiai.nome.toLowerCase() : '';
      const codigo = typeof item.codigo === 'string' ? item.codigo.toLowerCase() : '';
      const descricao = typeof item.descricao === 'string' ? item.descricao.toLowerCase() : '';
      const ean = typeof item.ean === 'string' ? item.ean.toLowerCase() : '';
    
      return (
        (!filters.nome || nome.includes(filters.nome.toLowerCase())) &&
        (!filters.codigo || codigo.includes(filters.codigo.toLowerCase())) &&
        (!filters.descricao || descricao.includes(filters.descricao.toLowerCase())) &&
        (!filters.ean || ean.includes(filters.ean.toLowerCase()))
      );
    });
    this.setState({ filteredList });
  }

  render() {
    const { filteredList, isLoaded, filters , mensagem} = this.state;
    const headerStyles = { display: "flex", justifyContent: "space-between" };

    return (
      <CRow>
        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader style={headerStyles}>
              Produtos  {mensagem}
            </CCardHeader>
            {isLoaded && <CSpinner color="success" style={{ marginLeft: '50%', alignItems: "center" }} />}
            <CCardBody>
              <div className="mb-3">
                <CRow>
                  <CCol md={2}>
                    <CFormInput
                      placeholder="Filial"
                      name="nome"
                      value={filters.nome}
                      onChange={this.handleFilterChange}
                    />
                  </CCol>
                  <CCol md={2}>
                    <CFormInput
                      placeholder="Código Produto"
                      name="codigo"
                      value={filters.codigo}
                      onChange={this.handleFilterChange}
                    />
                  </CCol>
                  <CCol md={3}>
                    <CFormInput
                      placeholder="Descrição"
                      name="descricao"
                      value={filters.descricao}
                      onChange={this.handleFilterChange}
                    />
                  </CCol>
                  <CCol md={2}>
                    <CFormInput
                      placeholder="EAN"
                      name="ean"
                      value={filters.ean}
                      onChange={this.handleFilterChange}
                    />
                  </CCol>
                  <CCol md={3}>
                    <div >
                   <CButton
                    onClick={this.CallCarga} disabled={isLoaded}
                   >Efetuar Carga</CButton>
                   </div>
                 </CCol> 
                </CRow>
              </div>
              <div style={{ overflowX: 'auto' }}>
                <CTable
                  align="middle"
                  className="mb-0 border card-body-table table"
                  hover
                  responsive
                  small
                  bordered
                  style={{ fontFamily: "Arial", minWidth: '100%' }}
                >
                  <CTableHead color="dark">
                    <CTableRow color="dark">
                      <CTableHeaderCell>Filial</CTableHeaderCell>
                      <CTableHeaderCell>Código</CTableHeaderCell>
                      <CTableHeaderCell>Descrição</CTableHeaderCell>
                      <CTableHeaderCell>EAN</CTableHeaderCell>              
                      <CTableHeaderCell>Valor</CTableHeaderCell>                            
                      <CTableHeaderCell>Família</CTableHeaderCell>           
                      <CTableHeaderCell>Garantia</CTableHeaderCell>                      
                      <CTableHeaderCell>Inativo</CTableHeaderCell>                      
                      <CTableHeaderCell>Unidade</CTableHeaderCell>      
                      <CTableHeaderCell>Carga</CTableHeaderCell>                
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {filteredList.map((item, index) => (
                      <CTableRow key={index}  style={{ color: "green" }}>
                        <CTableDataCell>{item.filiai.nome}</CTableDataCell>
                        <CTableDataCell>{item.codigo}</CTableDataCell>
                        <CTableDataCell>{item.descricao}</CTableDataCell>
                        <CTableDataCell>{item.ean}</CTableDataCell>                  
                        <CTableDataCell>{item.valor_unitario}</CTableDataCell>                                            
                        <CTableDataCell>{item.descricao_familia}</CTableDataCell>
                        <CTableDataCell>{item.dias_garantia}</CTableDataCell>                       
                        <CTableDataCell>{item.inativo}</CTableDataCell>                       
                        <CTableDataCell>{item.unidade}</CTableDataCell>    
                        <CTableDataCell>{this.formatDate(item.createdat)}</CTableDataCell>                    
                      </CTableRow>
                    ))}
                  </CTableBody>
                </CTable>
              </div>           
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    );
  }
}

